import { FC } from 'react'
import cn from 'classnames'
import { NavLink } from 'react-router-dom'

import logo from '@src/images/header_logo.svg'
import odnokl from '@src/images/odnoklassniki_ico.svg'
import vk from '@src/images/vk_ico.svg'
import insta from '@src/images/instagram_ico.svg'
import youTube from '@src/images/youtube_ico.svg'
import phone from '@src/images/phone_header.svg'
import style from '@src/components/Footer/Footer.module.scss'
import moment from 'moment'

type FooterProps = {
  className?: string
}

export const Footer: FC<FooterProps> = ({ className }) => (
  <div className={cn(style.section, className)}>
    <div className={cn(style.container, 'container')}>
      <div className={style.footerBox}>
        <div className={style.logoBox}>
          <NavLink
            to="/"
          >
            <img
              src={logo}
              alt="logo"
              className="logo"
            />
          </NavLink>
          <div>
            © 1993 -
            {' '}
            {moment().format('YYYY')}
            {' '}
            СООО «КОСМОС ТВ». Все права защищены.
          </div>
        </div>
        <div className={style.logoBox}>
          <p>без выходных</p>
          <div className={style.number}><a href="tel:+375 (17) 289-29-29">+375 (17) 289-29-29</a></div>
          <div className={style.description}>Техподдержка с 9:00 до 23:00</div>
        </div>
        <div className={style.logoBox}>
          <p>напишите нам</p>
          <div className={style.number}>
            <a href="mailto:info@cosmostv.com">info@cosmostv.com</a>
          </div>

        </div>
        <div className={style.logoBox}>
          <p>мы в социальных сетях</p>
          <div className={style.footer_icons}>
            <a target="_blank" href="https://www.instagram.com/cosmostelecom.by/" rel="noreferrer">
              <div className={style.footer_icon}>
                <img
                  src={insta}
                  alt="Ссылка на сайт инстаграм"
                />
              </div>

            </a>
            <a target="_blank" href="https://ok.ru/cosmostelecom" rel="noreferrer">
              <div className={style.footer_icon}>
                <img
                  src={odnokl}
                  alt="Ссылка на сайт Одноклассники"
                />
              </div>
            </a>
            <a target="_blank" href="https://www.youtube.com/channel/UCIWmAmXL1xR08Bm3-wqNgIQ/feed" rel="noreferrer">
              <div className={style.footer_icon}>
                <img
                  src={youTube}
                  alt="Ссылка на сайт youtube"
                />
              </div>
            </a>
            <a target="_blank" href="https://vk.com/cosmos_telecom" rel="noreferrer">
              <div className={`${style.footer_icon} ${style.vk}`}>
                <img
                  src={vk}
                  alt="Ссылка на сайт ВКонтакте"
                />
              </div>
            </a>
          </div>
        </div>

        <div className={cn(style.logoBox, style.phoneBox)}>
          <div className={style.footerContainer}>
            <a href="tel:134">
              <img
                src={phone}
                alt="phone"
              />
              <div className={style.number}>134</div>
            </a>

          </div>
        </div>

      </div>
    </div>
  </div>
)
